import React from 'react';

interface SessionExpiredMessageProps {
  onRefresh: () => void;
}

export const SessionExpiredMessage: React.FC<SessionExpiredMessageProps> = ({ onRefresh }) => {
  return (
    <div className="privacy-message">
      <div className="privacy-content">
        Chat session has expired after 30 minutes. Please refresh the page to start a new chat.
      </div>
      <div className="btn-wrapper" style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <button 
          className="accept-btn" 
          onClick={onRefresh}
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}; 